export class ExportProjectDeposits {
    constructor(
        public id: number,
        public projectIds: number[],
        public depositDateFrom?: string,
        public depositDateTo?: string,
    ) {}
}
